module.exports = __webpack_public_path__ + "img/76080738001069.e6701de1.png";